import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";

import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { adminThemeSale} from "@/services/api/cresivoxServer";
// import AdminThemeSale from "@/services/api/cresivoxServer/adminThemeSale";


import { REDUCER_NAME,iThemeForm } from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const adminThemeSaleList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("adminThemeSaleList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types

  async (payload, {rejectWithValue}) => {
    try {
      const response = await adminThemeSale.adminThemeSaleList();
      if (response) {
        const {httpStatusCode, data, message} = response;
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            // console.log("this is data for all theme sale",data.data);
            if (data && data.data) {
              return {
                data: {
                  data: data.data,
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);


